export * as Queries from './queries';
// export * as Mutations from './mutations'; // No mutations to export. Uncomment this line when adding a mutation.
export * as Types from './types';

import { useReviewsAggregatorV1QueryUpdaters } from './query-updaters';
/**
 * Query updaters should only be used internally by mutations in an api library that affects reviews-aggregator-v1 queries
 */
export const _QueryUpdaters = { useQueryUpdaters: useReviewsAggregatorV1QueryUpdaters };
